import { ChevronLeft, ChevronRight } from "lucide-react"
import { IconButton } from "./icon-button"

interface NavigationButtonsProps {
  onGoBack?: () => void
  onGoForward?: () => void
  canGoBack?: boolean
  canGoForward?: boolean
  backTestId?: string
  forwardTestId?: string
  className?: string
}

/**
 * Reusable navigation buttons component for back/forward navigation
 * Used in both Explorer and Document viewer
 */
export function NavigationButtons({
  onGoBack,
  onGoForward,
  canGoBack = false,
  canGoForward = false,
  backTestId,
  forwardTestId,
  className = ""
}: NavigationButtonsProps) {
  return (
    <div 
      className={`flex items-center gap-0.5 mr-2 border-r border-border pr-2 ${className}`}
      role="group" 
      aria-label="Navigation"
    >
      <IconButton
        icon={<ChevronLeft className="h-4 w-4" />}
        label="Go back"
        shortcut="⌘["
        variant="ghost"
        size="sm"
        onClick={onGoBack}
        disabled={!canGoBack}
        data-testid={backTestId}
      />
      <IconButton
        icon={<ChevronRight className="h-4 w-4" />}
        label="Go forward"
        shortcut="⌘]"
        variant="ghost"
        size="sm"
        onClick={onGoForward}
        disabled={!canGoForward}
        data-testid={forwardTestId}
      />
    </div>
  )
}

